import React, { useState, useEffect, Fragment, useCallback } from 'react';
import axios from 'axios';
import constants from '../../constants';
import Loader from '../Common/Loader';
import { cookieStorageUtility, localStorageUtility } from '../../utils/utilityFunctions';
// import { history } from '../../redux/store';

const { serverUrl, ENCRYPTOR_KEY, REDIRECT_URL } = constants;
const authUserId = cookieStorageUtility.fetch('auth_user_id');
const encryptedToken = cookieStorageUtility.fetch('encrypted_' + ENCRYPTOR_KEY + '_token');

const HeaderSideBar = ({ toggleSideBar }) => {
  const [hotelList, setHotelList] = useState([]);
  const [showUILoader, setShowUILoader] = useState(false);
  const [total, setTotal] = useState('');
  const [limit] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [pageRangeDisplayed] = useState(1);
  const [flag, setFlag] = useState(false);
  const [type, setType] = useState('');
  const [message, setMessage] = useState('');

  const getHotelList = useCallback(() => {
    setShowUILoader(true);
    const param = {
      page: pageNumber,
      limit: limit,
      hotelId: 0
    };
    axios(serverUrl + 'property/gethotellisting', {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        token: btoa(authUserId + '|' + encryptedToken)
      },
      data: { param }
    }).then(response => {
      if (response.data.status === 'success') {
        setHotelList(response.data.data.list);
        setTotal(response.data.count);
      } else {
        showMessage('error', response.data.message);
      }
      setShowUILoader(false);
    }).catch(error => {
      console.log(error);
      setShowUILoader(false);
    });
  }, [pageNumber, limit]);

  useEffect(() => {
    getHotelList();
  }, [getHotelList]);

const loginHotel = (val) => {
    const identity = localStorageUtility.fetch('identity') || {};
    if (identity.hotel_id === val.hotelId) {
        return '';
    }
    setShowUILoader(true);
    identity.hotel_id = val.hotelId || 'new_requested';
    identity.hotel_name = val.hotel || 'New Hotel';
    identity.sync_allowed = val.sync_allowed || false;
    localStorageUtility.create('identity', identity);
    cookieStorageUtility.create('hotelId', val.hotelId || 'new_requested');
    cookieStorageUtility.create('isEzeykey', val.is_ezeykey || false);
    const pathname = ''; // history.location.pathname.split('/');
    if (pathname[1] === 'property' && pathname[2] === 'setup') {
        window.open(REDIRECT_URL + '/property/setup/' + (val.hotelId || 'new_requested'), '_self');
    } else {
        window.location.reload();
    }
    return true;
};

  const showMessage = (type, message) => {
    setFlag(true);
    setType(type);
    setMessage(message);
    setTimeout(() => {
      setFlag(false);
    }, 3000);
  };

  const filterHotelList = (e) => {
    setShowUILoader(true);
    const param = {
      page: pageNumber,
      limit: limit,
      hotelId: 0
    };
    if (typeof e !== 'undefined' && e.target.value.length > 2) {
      param.hotelName = e.target.value;
      param.page = 1;
      axios(serverUrl + 'property/gethotellisting', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
          token: btoa(authUserId + '|' + encryptedToken)
        },
        data: { param }
      }).then(response => {
        if (response.data.status === 'success') {
          setHotelList(response.data.data.list);
          setTotal(response.data.count);
        } else {
          showMessage('error', response.data.message);
        }
        setShowUILoader(false);
      }).catch(error => {
        console.log(error);
        setShowUILoader(false);
      });
    } else {
      setShowUILoader(false);
    }
  };

  const renderList = () => {
    const identity = localStorageUtility.fetch('identity');
    if (hotelList.length > 0) {
        return hotelList.map((val, id) => {
            return (
                <div key={id} className="table_row border_b_1 border_color_1">
                <div className="tabcel align_top pad_top_bot5 pad_lft_rht10">
                    {val.hotel}|({val.hotel_code})
                    <div className="ovr fnt12 margtop5 color2_2">{`${val.city}, ${val.country}`}</div>
                </div>
                <div className="tabcel align_middle pad_top_bot5 pad_lft_rht10 wdhpx50">
                    {identity && identity.hotel_id === val.hotelId ? (
                        <i className="fa fa-check fnt15 color4" title="Logged In"></i>
                    ) : (
                        <i
                            className="fa fa-sign-in fnt15 cursor_p color7"
                            title="Login"
                            onClick={() => loginHotel(val)}
                        ></i>
                    )}
                    {/* <i className={`fa fa-sign-in fnt15 cursor_p ${identity.hotel_id === val.hotelId ? 'color4' : 'color7'}`} title="Login" onClick={() => this.loginHotel(val)}></i> */}
                </div>
                </div>
            );
        });
    };
  };
 

  const handlePageChange = (pageNumber) => {
    setPageNumber(pageNumber);
  };

  return (
    <Fragment>
     <div className="header_slidebar header_sidebar_show">
          {flag ? (
            <div
              className={`alert_col posfixed pad10 tc fnt16 bld ${type === 'error' ? 'danger' : 'success'}`}
            >
              {message}
            </div>
          ) : (
            ''
          )}
          <div className="d-full-height bg1 header_sidebar_container text-start">
            <div className="flex_top border_b_1 border_color_1 pad_lft_rht10">
              <div onClick={() => toggleSideBar(false)} className="inline cursor_p margtop2 header_slider_close">
                <i className="fa fa-times color5_2"></i></div>
              <div className="cover margtop5">
                <div className="frm border_all_1 border_color_1">
                  <span className="ficon pad_lft_rht10"> <i className="fa fa-search"></i></span>
                  <input type="text" placeholder="Search Property" className="input pad_lft_rht10" onKeyUp={(e) => filterHotelList(e)} />
                </div>
                <div className="ovr tr bld margtop10">Count : {total}<span id='count'></span></div>
              </div>
            </div>

            <div className="flex_content">
              {showUILoader && <Loader />}
              <div className="scroll_colum ovr">
                <div className="scroll_inner ovr">
                  <div className="table_col table_fixed" id='hotelList'>
                    {renderList()}
                  </div>
                </div>
              </div>
            </div>
            {total > limit ? (
              <div className="cover tc margtop15">
                {/* <Pagination
                  activePage={pageNumber}
                  itemsCountPerPage={limit}
                  totalItemsCount={total}
                  pageRangeDisplayed={pageRangeDisplayed}
                  onChange={handlePageChange}
                /> */}
              </div>
            ) : (
              ''
            )}
          </div>
        </div>
    </Fragment>
  );
};

export default HeaderSideBar;
